module.exports = __webpack_public_path__ + "img/s6on.8075252d.svg";